<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex sm4>
        <div class="headline green--text text--darken-4 font-weight-medium">
          Print Address
        </div>
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <v-layout row wrap>
          <div class="filterStyle">
            <v-text-field label="Patient Id:" v-model="patientId">
              <template slot="prepend">
                <v-icon class="filterIcon grey--text text--darken-1"
                  >fa fa-filter</v-icon
                >
              </template>
            </v-text-field>
          </div>
          <v-flex sm3>
            <v-btn
              color="primary"
              :disabled="loading"
              @click="add_patient_address"
            >
              <v-icon class="iconText">fa fa-plus</v-icon>
              Add Patient with Patient Address
            </v-btn>
          </v-flex>
          <v-flex sm3>
            <v-btn
              color="primary"
              :disabled="loading"
              @click="add_doctor_address"
            >
              <v-icon class="iconText">fa fa-plus</v-icon>
              Add Patient with Doctor Address
            </v-btn>
          </v-flex>
        </v-layout>
        <br />
      </v-flex>
      <v-flex sm2>
        <v-btn color="primary" outline @click="printAddress">
          <v-icon class="iconText">fa fa-print</v-icon>
          Print
        </v-btn>
      </v-flex>
      <v-flex sm12 lg12>
        <br />
      </v-flex>
      <v-flex lg12 sm12 xs12>
        <v-card class="elevation-0">
          <v-card-text>
            <div id="addressDoc">
              <div v-for="(group, i) in PrintLabels" :key="i">
                <PAddressV1 :labels="group"></PAddressV1>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <!--      <v-flex sm2>-->
      <!--        <v-btn :disabled="loading">-->
      <!--          <v-icon class="iconText">fa fa-plus</v-icon>-->
      <!--          Add All Patient Address-->
      <!--        </v-btn>-->
      <!--      </v-flex>-->
      <!--      <v-flex sm2>-->
      <!--        <v-btn :disabled="loading">-->
      <!--          <v-icon class="iconText">fa fa-trash</v-icon>-->
      <!--          Clear Address List-->
      <!--        </v-btn>-->
      <!--      </v-flex>-->
    </v-layout>
  </v-container>
</template>

<script>
import PAddressV1 from "../../components/prescription/PAddressV1";
import WebH from "../../api/web";
export default {
  components: {
    PAddressV1
  },
  data() {
    return {
      loading: false,
      patientId: "",
      addresses: []
    };
  },
  computed: {
    PrintLabels() {
      let gLen = Math.floor(this.addresses.length / 8);
      const rem = this.addresses.length % 8;
      if (rem > 0) gLen++;
      const items = [];
      for (let i = 0; i < gLen; i++) {
        const nodes = [];
        const start = i * 8;
        let limit = 8;
        if (this.addresses.length <= start + 8)
          limit = this.addresses.length - start;
        for (let j = 0; j < limit; j++) {
          nodes.push(this.addresses[start + j]);
        }
        items.push(nodes);
      }
      return items;
    }
  },
  methods: {
    printAddress() {
      this.$htmlToPaper("addressDoc");
    },
    add_patient_address() {
      this.api_getPatient(false);
    },
    add_doctor_address() {
      this.api_getPatient(true);
    },
    async api_getPatient(enableDoctor) {
      this.loading = true;
      let url = "/patients/get_address?";
      url += "pid=" + this.patientId;
      url += "&edoc=" + enableDoctor;
      const res = await WebH.Get(url, "address");
      if (res.Success) {
        const address = res.Data;
        address.DocEnabled = enableDoctor;
        this.addresses.push(address);
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
